import * as React from 'react';
import PageMain from '../../components/Navigation/PageMain/PageMain';
import NotificationSettings from '../../components/Settings/NotificationSettings/NotificationSettings';
import { useRequestClientParameters } from '../../sic-lib/api/hooks/useUserConfig';

export default function NotificationSettingsPage() {
    // const { requestStatus, asyncRequestNotificationSettings } =
    //     useAsyncRequestNotificationSettings();

    const { data: clientParameters, isLoading: isRefreshingClientParameters } =
        useRequestClientParameters({
            names: ['EnablePushNotifications'],
        });

    const hasPushNotifications = React.useMemo(() => {
        return Boolean(
            Number(clientParameters?.find(x => x.name === 'EnablePushNotifications')?.value),
        );
    }, [clientParameters]);

    return (
        <PageMain pageTitle="Notification Settings" showError={false} showLoading={false}>
            <div className="settingsPage">
                <div className="settingsPage__wrapper">
                    <NotificationSettings
                        notification={hasPushNotifications}
                        isRefreshingClientParameters={isRefreshingClientParameters}
                    />
                </div>
            </div>
        </PageMain>
    );
}
